// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file entities/app/my_account/union_membership.proto (package protos.entities.app.my_account, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { WorkFunction } from "../../../general/work_function_pb";
import { file_general_work_function } from "../../../general/work_function_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file entities/app/my_account/union_membership.proto.
 */
export const file_entities_app_my_account_union_membership: GenFile = /*@__PURE__*/
  fileDesc("Ci5lbnRpdGllcy9hcHAvbXlfYWNjb3VudC91bmlvbl9tZW1iZXJzaGlwLnByb3RvEh5wcm90b3MuZW50aXRpZXMuYXBwLm15X2FjY291bnQipAIKD1VuaW9uTWVtYmVyc2hpcBIQCgh1bmlvbl9pZBgBIAEoCRITCgtpc192ZXJpZmllZBgCIAEoCBITCgt5ZWFyX2pvaW5lZBgDIAEoDRIZChFtZW1iZXJzaGlwX3N0YXR1cxgEIAEoCRIVCg1tZW1iZXJzaGlwX2lkGAUgASgJEl4KE2NlcnRpZmllZF9mdW5jdGlvbnMYBiADKAsyQS5wcm90b3MuZW50aXRpZXMuYXBwLm15X2FjY291bnQuVW5pb25NZW1iZXJzaGlwLkNlcnRpZmllZEZ1bmN0aW9uGkMKEUNlcnRpZmllZEZ1bmN0aW9uEi4KCGZ1bmN0aW9uGAEgASgOMhwucHJvdG9zLmdlbmVyYWwuV29ya0Z1bmN0aW9uYgZwcm90bzM", [file_general_work_function]);

/**
 * @generated from message protos.entities.app.my_account.UnionMembership
 */
export type UnionMembership = Message<"protos.entities.app.my_account.UnionMembership"> & {
  /**
   * @generated from field: string union_id = 1;
   */
  unionId: string;

  /**
   * @generated from field: bool is_verified = 2;
   */
  isVerified: boolean;

  /**
   * @generated from field: uint32 year_joined = 3;
   */
  yearJoined: number;

  /**
   * @generated from field: string membership_status = 4;
   */
  membershipStatus: string;

  /**
   * @generated from field: string membership_id = 5;
   */
  membershipId: string;

  /**
   * @generated from field: repeated protos.entities.app.my_account.UnionMembership.CertifiedFunction certified_functions = 6;
   */
  certifiedFunctions: UnionMembership_CertifiedFunction[];
};

/**
 * Describes the message protos.entities.app.my_account.UnionMembership.
 * Use `create(UnionMembershipSchema)` to create a new message.
 */
export const UnionMembershipSchema: GenMessage<UnionMembership> = /*@__PURE__*/
  messageDesc(file_entities_app_my_account_union_membership, 0);

/**
 * @generated from message protos.entities.app.my_account.UnionMembership.CertifiedFunction
 */
export type UnionMembership_CertifiedFunction = Message<"protos.entities.app.my_account.UnionMembership.CertifiedFunction"> & {
  /**
   * @generated from field: protos.general.WorkFunction function = 1;
   */
  function: WorkFunction;
};

/**
 * Describes the message protos.entities.app.my_account.UnionMembership.CertifiedFunction.
 * Use `create(UnionMembership_CertifiedFunctionSchema)` to create a new message.
 */
export const UnionMembership_CertifiedFunctionSchema: GenMessage<UnionMembership_CertifiedFunction> = /*@__PURE__*/
  messageDesc(file_entities_app_my_account_union_membership, 0, 0);

